import { Box, styled } from "@mui/material";

export const WarningBox = styled(Box)`
  position: relative;
  margin-top: 1rem;

  button {
    position: absolute;
    right: 0;
    top: 0;
  }
`;

export const WarningTitle = styled("div")`
  font-weight: bold;
`;

export const WarningItem = styled("div")`
  margin-bottom: 0.3rem;
  font-size: 0.8rem;
`;
